export default class QueryEncoder {
  public static encodeURI(obj: any, prefix?: string) {
      let str = [];
      for(let p in obj) {
        if (obj.hasOwnProperty(p) && obj[p] != null) {
          if(typeof obj[p] == 'object') {
            let substr = this.encodeURI(obj[p], p);
            str.push(substr);
          } else {
            if(prefix) {
              str.push(prefix + '[' + encodeURIComponent(p) + ']' + '=' + encodeURIComponent(obj[p]));
            } else {
              str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
          }
        }
      }
      return str.join('&');
  }
}
